import { ITerm } from "@evennt-tech/api-v2-core";

/**
 * A section's `pinned` as the list last loaded it. The section form has no pin
 * field, but the edit call overwrites the whole row, so a save must carry it.
 */
const currentPinned = (terms: ITerm[], termId: string): boolean =>
  terms.find(({ id }) => id === termId)?.pinned ?? false;

export default currentPinned;
